import React from 'react';
import { Link } from 'react-router-dom';
import './TradingSignals.css';

const TradingSignals: React.FC = () => {
  return (
    <div className="trading-signals-page">
      <div className="container">
        <div className="page-title">
          <h1>Trading Signals</h1>
          <p>Professional trading signals to guide your investment decisions</p>
        </div>
        
        <div className="signals-intro">
          <div className="signals-content">
            <h2>What Are Trading Signals?</h2>
            <p>Trading signals are professional recommendations that provide precise entry and exit points for trading financial instruments. These signals are generated by experienced traders and sophisticated algorithms based on technical analysis, market trends, and economic indicators.</p>
            
            <div className="signals-features">
              <div className="feature">
                <h3>Real-Time Alerts</h3>
                <p>Receive immediate notifications when new trading opportunities arise across various markets.</p>
              </div>
              
              <div className="feature">
                <h3>Detailed Analysis</h3>
                <p>Each signal comes with comprehensive market analysis and reasoning behind the trade recommendation.</p>
              </div>
              
              <div className="feature">
                <h3>Risk Management</h3>
                <p>Clear stop-loss and take-profit levels to help manage your risk effectively.</p>
              </div>
            </div>
          </div>
          
          <div className="signals-visual">
            <div className="signal-card">
              <h3>Example Signal</h3>
              <div className="signal-info">
                <div className="signal-row">
                  <span className="label">Currency:</span>
                  <span className="value">EUR/USD</span>
                </div>
                <div className="signal-row">
                  <span className="label">Action:</span>
                  <span className="value buy">BUY</span>
                </div>
                <div className="signal-row">
                  <span className="label">Entry:</span>
                  <span className="value">1.0850</span>
                </div>
                <div className="signal-row">
                  <span className="label">Stop-Loss:</span>
                  <span className="value">1.0800</span>
                </div>
                <div className="signal-row">
                  <span className="label">Take-Profit:</span>
                  <span className="value">1.0950</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="how-it-works">
          <h2>How Trading Signals Work</h2>
          
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Market Analysis</h3>
              <p>Our professional traders and algorithms analyze market conditions using technical and fundamental analysis.</p>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <h3>Signal Generation</h3>
              <p>When a high-probability trading opportunity is identified, a signal is generated with entry, exit, and risk parameters.</p>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <h3>Real-Time Delivery</h3>
              <p>Signals are sent to subscribers via our platform, email, and mobile notifications.</p>
            </div>
            
            <div className="step">
              <div className="step-number">4</div>
              <h3>Execution</h3>
              <p>Traders execute the signal on their trading platform, following the provided instructions.</p>
            </div>
          </div>
        </div>
        
        <div className="markets-covered">
          <h2>Markets We Cover</h2>
          
          <div className="markets-grid">
            <div className="market-category">
              <h3>Forex</h3>
              <ul>
                <li>Major pairs (EUR/USD, GBP/USD, USD/JPY)</li>
                <li>Minor pairs (EUR/GBP, GBP/JPY, AUD/USD)</li>
                <li>Exotic pairs (USD/TRY, USD/THB, EUR/TRY)</li>
              </ul>
            </div>
            
            <div className="market-category">
              <h3>Indices</h3>
              <ul>
                <li>US Indices (S&P 500, NASDAQ, Dow Jones)</li>
                <li>European (FTSE 100, DAX, CAC 40)</li>
                <li>Asian (Nikkei, Hang Seng, ASX 200)</li>
              </ul>
            </div>
            
            <div className="market-category">
              <h3>Commodities</h3>
              <ul>
                <li>Metal (Gold, Silver, Platinum)</li>
                <li>Energies (Crude Oil, Brent Oil, Natural Gas)</li>
                <li>Agriculture (Corn, Wheat, Coffee)</li>
              </ul>
            </div>
            
            <div className="market-category">
              <h3>Cryptocurrencies</h3>
              <ul>
                <li>Major coins (Bitcoin, Ethereum, Ripple)</li>
                <li>Altcoins (Cardano, Litecoin, Chainlink)</li>
                <li>DeFi tokens (Uniswap, Aave, Compound)</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="signals-benefits">
          <h2>Benefits of Using Trading Signals</h2>
          
          <div className="benefits-grid">
            <div className="benefit">
              <h3>Time-Saving</h3>
              <p>Eliminate the need to constantly monitor markets and analyze charts yourself.</p>
            </div>
            
            <div className="benefit">
              <h3>Expert Knowledge</h3>
              <p>Leverage the expertise of professional traders and advanced algorithms.</p>
            </div>
            
            <div className="benefit">
              <h3>Emotional Control</h3>
              <p>Follow objective signals to reduce emotional trading decisions.</p>
            </div>
            
            <div className="benefit">
              <h3>Learning Opportunity</h3>
              <p>Improve your trading skills by following and understanding professional strategies.</p>
            </div>
          </div>
        </div>
        
        <div className="cta-section">
          <h2>Ready to Start Using Professional Trading Signals?</h2>
          <p>Join thousands of successful traders who rely on our signals to guide their investment decisions.</p>
          <Link to="/services" className="btn primary">Get Started Today</Link>
        </div>
      </div>
    </div>
  );
};

export default TradingSignals;